import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../contexts/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [error, setError] = useState(null);
  const processedRef = useRef(false);

  useEffect(() => {
    if (processedRef.current) return;
    processedRef.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }

    (async () => {
      try {
        const res = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        setUser({
          user_id: res.data.user_id,
          email: res.data.email,
          name: res.data.name,
          picture: res.data.picture,
        });
        // Store session token in sessionStorage for WebSocket auth (cookies are httpOnly)
        if (res.data.session_token) {
          window.sessionStorage.setItem("checkpoint_session_token", res.data.session_token);
        }
        // Clear the hash and go home
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/", { replace: true });
      } catch (e) {
        setError("Échec de la connexion. Réessayez.");
        setTimeout(() => navigate("/", { replace: true }), 2000);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="h-screen w-screen bg-slate-900 flex items-center justify-center">
      <div className="text-center">
        {!error ? (
          <>
            <div className="w-12 h-12 mx-auto border-4 border-sky-400 border-t-transparent rounded-full animate-spin mb-4"></div>
            <p className="font-display text-xl text-slate-300">Connexion en cours...</p>
          </>
        ) : (
          <p className="text-rose-400 font-display text-xl">{error}</p>
        )}
      </div>
    </div>
  );
};

export default AuthCallback;
